var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataListStateful',{attrs:{"title":"Подвижной состав","resource":"rolling-stocks","columns":_vm.columns,"store":"rollingStocks","filter-options":_vm.filter}})
}
var staticRenderFns = []

export { render, staticRenderFns }